/* eslint-disable arrow-parens */
export function initProductsFromOrders(orders) {
    const productsMap = new Map();

    orders.forEach(order => {
        const { pid } = order;

        const transformedSubItems = (order.pSubItems || []).map(subItem => ({
            type: subItem.type || 'option',
            required: 0,
            list: [{
                name: subItem.name,
                price: subItem.price || 0
            }]
        }));

        if (!productsMap.has(pid)) {
            productsMap.set(pid, {
                id: pid,
                name: order.pName,
                price: order.pPriceNoSubItems || order.pPrice,
                subItems: transformedSubItems
            });
            return;
        }

        const existingProduct = productsMap.get(pid);

        transformedSubItems.forEach(newSubItem => {
            const existingSubItem = existingProduct.subItems.find(
                s => s.type === newSubItem.type
            );

            if (existingSubItem) {
                newSubItem.list.forEach(newListItem => {
                    const existsInList = existingSubItem.list.some(
                        item => item.name === newListItem.name
                    );

                    if (!existsInList) {
                        existingSubItem.list.push(newListItem);
                    }
                });
            } else {
                existingProduct.subItems.push(newSubItem);
            }
        });
    });

    const products = Array.from(productsMap.values());
    return products;
}
